import { axios } from '@Root/API'

export const get = snapshotId => {
	return axios.get(`snapshots/${snapshotId}`)
}
